import React, { HTMLAttributes, useEffect, useState } from 'react';
import { Link } from './Link';
import { useRouter } from 'next/router';
import { toTitleCase } from '~/utils/stringUtils';

interface BreadcrumbsProps extends HTMLAttributes<HTMLElement> {
  pageTitle?: string;
  path?: string;
  listItemProps?: HTMLAttributes<HTMLElement>;
  linkProps?: HTMLAttributes<HTMLElement>;
}

export function Breadcrumbs({
  pageTitle,
  path,
  listItemProps,
  linkProps,
  ...props
}: BreadcrumbsProps) {
  const router = useRouter();
  const pathToUse = (path ?? router.asPath).split('?')[0];
  let pathSlugs = pathToUse.split('/').filter((slug) => slug !== '');

  if (pathSlugs.includes('learning-center')) {
    pathSlugs = pathSlugs.slice(0, 2);
  }

  const titles = pathSlugs.map(
    (slug) => `${slug[0].toUpperCase()}${slug.substring(1).replace(/-/g, ' ')}`
  );
  const [firstRender, setFirstRender] = useState(true);

  useEffect(() => setFirstRender(false), [firstRender]);

  if (pageTitle) {
    titles.splice(-1, 1, pageTitle);
  }

  return firstRender ? null : (
    <div data-testid="breadcrumbs" {...props}>
      <ul>
        {pathSlugs.map((slug, index) => (
          <li
            key={slug}
            className="inline before:mx-2 before:content-['>'] first:before:content-none"
            {...listItemProps}
          >
            <Link
              path={`/${pathSlugs.slice(0, index + 1).join('/')}`}
              title={toTitleCase(titles[index])}
              {...linkProps}
            />
          </li>
        ))}
      </ul>
    </div>
  );
}
